<template>
  <div class="meeting-details max-content">
    <!-- <audio
            v-if="backgroundMusicUrl"
            ref="bgm"
            :src="backgroundMusicUrl"
            loop
            preload="auto"
            playsinline
            webkit-playsinline
            @play="onBgmPlay"
            @pause="onBgmPause"
        ></audio>
        <div
            v-if="backgroundMusicUrl"
            class="bgm-control"
            :class="{ playing: bgmPlaying }"
            @click.stop="toggleBgm"
            role="button"
            aria-label="背景音乐"
        >
            <van-icon class="bgm-icon" name="music-o" />
        </div> -->
    <img class="bg" :src="backgroundImage" alt="" />
    <div class="relation787" v-if="meetingButton.length > 0">
      <van-row>
        <van-col span="8">
          <a
            href="Javascript:void(0)"
            title="picname"
            @click="skipLink(meetingButton[0])"
          >
            <img :src="meetingButton[0].icon" alt="" />
          </a>
        </van-col>
        <van-col span="8">
          <a
            href="Javascript:void(0)"
            title="picname"
            @click="skipLink(meetingButton[1])"
          >
            <img :src="meetingButton[1].icon" alt="" />
          </a>
        </van-col>
        <van-col span="8">
          <a
            href="Javascript:void(0)"
            title="picname"
            @click="skipLink(meetingButton[2])"
          >
            <img :src="meetingButton[2].icon" alt="" />
          </a>
        </van-col>
      </van-row>
      <van-row>
        <van-col span="8">
          <a
            href="Javascript:void(0)"
            title="picname"
            @click="skipLink(meetingButton[3])"
          >
            <img :src="meetingButton[3].icon" alt="" />
          </a>
        </van-col>
        <van-col span="8">
          <a
            href="Javascript:void(0)"
            title="picname"
            @click="skipLink(meetingButton[4])"
          >
            <img :src="meetingButton[4].icon" alt="" />
          </a>
        </van-col>
        <van-col span="8">
          <a
            href="Javascript:void(0)"
            title="picname"
            @click="skipLink(meetingButton[5])"
          >
            <img :src="meetingButton[5].icon" alt="" />
          </a>
        </van-col>
      </van-row>
      <van-row>
        <van-col span="8">
          <a
            href="Javascript:void(0)"
            title="picname"
            @click="skipLink(meetingButton[6])"
          >
            <img :src="meetingButton[6].icon" alt="" />
          </a>
        </van-col>
        <van-col span="8">
          <a
            href="Javascript:void(0)"
            title="picname"
            @click="skipLink(meetingButton[7])"
          >
            <img :src="meetingButton[7].icon" alt="" />
          </a>
        </van-col>
        <van-col span="8">
          <a
            href="Javascript:void(0)"
            title="picname"
            @click="skipLink(meetingButton[8])"
          >
            <img :src="meetingButton[8].icon" alt="" />
          </a>
        </van-col>
      </van-row>
    </div>
    <!-- <bottom :name="meeting_name" :meeting_id="meeting_id" :show_support="show_support" v-if="bottom_word_show"> -->
    <!-- </bottom> -->
  </div>
</template>
<script>
import {
  MeetingButtons,
  MeetingsCarousel,
  MeetingsDetails,
  companyImages
} from "../../../config/interface.js";
export default {
  data() {
    return {
      meetingButton: {}, //会议按钮
      swiperImg: [],
      meeting_id: "787",
      time: "",
      backgroundImage:
        "https://cdn.sandbox.edstatic.com/202611081002/5e5fda2b4536314eb4ecd788025deb68/2026/05/12/15efda98a6e8fda83d4907581b91004a9af28288.jpg",
      /** 背景音乐 mp3/m4a 等直链，留空则不展示控件；也可由会议详情接口返回 background_music 覆盖 */
      backgroundMusicUrl: "",
      bgmPlaying: false,
      showTimeCountDown: false,
      show_support: 1,
      bottom_word_show: 0
    };
  },
  beforeRouteEnter(to, from, next) {
    //  修复iOS版微信HTML5 History兼容性问题
    if (to.path !== location.pathname) {
      location.assign(to.fullPath);
    } else {
      next();
    }
  },
  mounted() {
    this.getMeetingButtons(this.meeting_id);
    this.getMeetingCarousel();
    this.getMeetingDetails();
    // this.tryAutoplayBgm()
  },
  beforeDestroy() {
    const el = this.$refs.bgm;
    if (el) {
      el.pause();
      el.src = "";
    }
  },
  methods: {
    getImages() {
      const url = companyImages;
      let params = {
        meeting_id: this.meeting_id
      };
      const method = "POST";
      fetch(url, params, method).then(res => {
        if (res.code == 0) {
          this.images = res.data;
        }
      });
    },
    //会议轮播
    getMeetingCarousel() {
      const url = MeetingsCarousel;
      let params = {
        meeting_id: this.meeting_id
      };
      const method = "POST";
      fetch(url, params, method).then(res => {
        if (res.code == 0) {
          let data = res.data;
          this.swiperImg = data;
        }
      });
    },
    clickSwiperImg(item) {
      window.location.href = item.link;
    },
    //会议按钮
    getMeetingButtons(id) {
      const url = MeetingButtons;
      const method = "POST";
      let params = {
        meeting_id: id
      };
      fetch(url, params, method).then(res => {
        if (res.code == 0) {
          let data = res.data;
          this.meetingButton = data;
          // console.log(this.meetingButton)
        }
      });
    },
    //会议详情
    getMeetingDetails() {
      const url = MeetingsDetails;
      const method = "POST";
      let params = {
        meeting_id: this.meeting_id
      };
      fetch(url, params, method).then(res => {
        if (res.code == 0) {
          let data = res.data;
          document.title = data.name;
          this.meeting_name = data.name;
          this.bottom_word_show = data.bottom_word_show;
          this.show_support = data.platform_support_show;
          //微信浏览器  请求jsdk
          if (common.is_weixin()) {
            common.wxShare(data.name, data.title, data.shareimg);
          }
        }
      });
    },
    countdownTo(targetDateString) {
      // 将目标日期字符串转换为Date对象
      const targetDate = new Date(targetDateString);
      // 获取当前时间的Date对象
      const currentDate = new Date();
      // 计算时间差（以毫秒为单位）
      const differenceMs = targetDate.getTime() - currentDate.getTime();
      // 返回剩余时间（如果为负数，则表示目标日期已过）
      return differenceMs;
    },
    tryAutoplayBgm() {
      if (!this.backgroundMusicUrl) return;
      this.$nextTick(() => {
        const el = this.$refs.bgm;
        if (!el) return;
        const p = el.play();
        if (p && typeof p.catch === "function") {
          p.catch(() => {});
        }
      });
    },
    toggleBgm() {
      const el = this.$refs.bgm;
      if (!el) return;
      if (this.bgmPlaying) {
        el.pause();
      } else {
        const p = el.play();
        if (p && typeof p.catch === "function") {
          p.catch(() => {});
        }
      }
    },
    onBgmPlay() {
      this.bgmPlaying = true;
    },
    onBgmPause() {
      this.bgmPlaying = false;
    },
    // 将 skipLink 方法移至此处
    skipLink(item) {
      console.log(item);
      if (item.url.match(/\.(jpeg|jpg|gif|png)$/)) {
        ImagePreview({
          images: [item.url],
          closeable: true,
          showIndex: false
        });
      } else {
        window.localStorage.removeItem("callback_url");
        window.localStorage.setItem("callback_url", item.url);
        window.location.href = item.url;

        if (
          item.url.indexOf("vascularnews/meeting/schedule") > -1 &&
          window.localStorage.getItem("schedule_date")
        ) {
          window.localStorage.removeItem("schedule_date");
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.meeting-details {
  background: #f6f7f9;
  display: flex;
  flex-direction: column;
  overflow: auto;
  position: relative;

  .bgm-control {
    position: fixed;
    top: 0.28rem;
    right: 0.28rem;
    z-index: 99;
    width: 0.88rem;
    height: 0.88rem;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.38);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.44rem;
    box-sizing: border-box;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;

    .bgm-icon {
      display: block;
    }

    &.playing .bgm-icon {
      animation: bgm-spin 8s linear infinite;
    }

    &:not(.playing) {
      opacity: 0.75;
    }
  }

  @keyframes bgm-spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  .bg {
    width: 100%;
    min-height: 100vh;
  }

  .banner-show {
    width: 100%;
    padding: 0px;

    .cover {
      width: 100%;

      img {
        width: 100%;
      }
    }
  }
  .relation787 {
    padding: 0.7rem 0.7rem;
    @include flex(row);
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
    position: absolute;
    z-index: 9;
    top: 40%;

    .van-row {
      width: 100%;
      line-height: 0;
    }

    .van-col {
      line-height: 0;
    }

    a {
      display: inline-block;
      text-align: center;
      line-height: 0;
      padding: 0.18rem 0.2rem;
      width: 100%;
      box-sizing: border-box;
      // margin-bottom: 16px;
    }

    img {
      width: 100%;
      height: 100%;
    }
  }
  @media screen and (min-width: 500px) {
    .relation787 {
      padding: 1.5rem 1.5rem;

      a {
        padding: 0.3rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/VascularSystem/Meeting787/index.vue